import React from "react";
import ConfirmDeleteButton from "../../Common/ConfirmDeleteButton";
import UIToggle from "../../Common/UIToggle";
import DistrictsDatalist from "../../Common/DistrictsDatalist";
import { ACCOUNT_DELETE_CONFIRM_TITLE } from "../../../constants/accountDeletion";
import {
   DEFAULT_INSTRUCTOR_TYPE,
   normalizeInstructorType,
} from "../../../constants/instructors";
import {
   PROFILE_COLOR_PALETTE,
   EDITABLE_INSTRUCTOR_TYPE_OPTIONS,
} from "./instructorProfileShared";

export default function InstructorMainTab({
   formData,
   handleFormChange,
   handleSaveEdit,
   saveError,
   saving,
   deleting = false,
   canDelete = false,
   canSetPassword = false,
   handleDeleteInstructor,
   handleResetProfile,
   colorButtonsRef,
   handleColorPointerDown,
   handleColorPointerMove,
   stopColorDrag,
   activeColorIndex,
   setColorFromIndex,
   setProfileDirty,
   setFormData,
}) {
  return (
               <div className="instructorProfileUI__section">
            <form
               className="instructorProfileUI__form"
               onSubmit={(event) => {
                  event.preventDefault();
                  handleSaveEdit();
               }}
            >
               <div className="instructorProfileUI__fieldGrid">
                  <label className="instructorProfileUI__field">
                     <span className="instructorProfileUI__fieldLabel">
                        Prenume
                     </span>
                     <input
                        name="firstName"
                        className="instructorProfileUI__input"
                        value={formData.firstName}
                        onChange={handleFormChange}
                        placeholder="Prenume"
                        autoComplete="given-name"
                     />
                  </label>

                  <label className="instructorProfileUI__field">
                     <span className="instructorProfileUI__fieldLabel">
                        Nume
                     </span>
                     <input
                        name="lastName"
                        className="instructorProfileUI__input"
                        value={formData.lastName}
                        onChange={handleFormChange}
                        placeholder="Nume"
                        autoComplete="family-name"
                     />
                  </label>

                  <label className="instructorProfileUI__field">
                     <span className="instructorProfileUI__fieldLabel">
                        Telefon
                     </span>
                     <input
                        name="phone"
                        className="instructorProfileUI__input"
                        value={formData.phone}
                        onChange={handleFormChange}
                        placeholder="Telefon"
                        autoComplete="tel"
                     />
                  </label>

                  <label className="instructorProfileUI__field">
                     <span className="instructorProfileUI__fieldLabel">
                        ID instructor
                     </span>
                     <input
                        name="instructorIdField"
                        className="instructorProfileUI__input"
                        value={formData.instructorIdField}
                        onChange={handleFormChange}
                        placeholder="ID instructor"
                     />
                  </label>

                  <label className="instructorProfileUI__field instructorProfileUI__field--full">
                     <span className="instructorProfileUI__fieldLabel">
                        Email
                     </span>
                     <input
                        name="email"
                        className="instructorProfileUI__input"
                        value={formData.email}
                        onChange={handleFormChange}
                        placeholder="Email"
                        autoComplete="email"
                     />
                  </label>

                  {canSetPassword ? (
                     <label className="instructorProfileUI__field instructorProfileUI__field--full">
                        <span className="instructorProfileUI__fieldLabel">
                           Parolă nouă
                        </span>
                        <input
                           name="newPassword"
                           type="password"
                           className="instructorProfileUI__input"
                           value={formData.newPassword || ""}
                           onChange={handleFormChange}
                           placeholder="Lasă gol ca să rămână parola actuală"
                           autoComplete="new-password"
                        />
                        <span className="instructorProfileUI__fieldHint">
                           Când contul trece la alt instructor: parola veche nu
                           mai merge, iar contul se deconectează de pe toate
                           dispozitivele.
                        </span>
                     </label>
                  ) : null}

                  <label className="instructorProfileUI__field">
                     <span className="instructorProfileUI__fieldLabel">
                        Sector
                     </span>
                     <input
                        name="sector"
                        className="instructorProfileUI__input"
                        value={formData.sector}
                        onChange={handleFormChange}
                        placeholder="Sector"
                        list="instructor-profile-districts"
                     />
                     <DistrictsDatalist id="instructor-profile-districts" />
                  </label>

                  <label className="instructorProfileUI__field">
                     <span className="instructorProfileUI__fieldLabel">
                        Nr. mașină
                     </span>
                     <input
                        name="carPlate"
                        className="instructorProfileUI__input"
                        value={formData.carPlate}
                        onChange={handleFormChange}
                        placeholder="Nr. mașină"
                     />
                  </label>

                  <div className="instructorProfileUI__field instructorProfileUI__field--full instructorProfileUI__field--panel">
                     <span className="instructorProfileUI__fieldLabel">
                        Culoare profil
                     </span>
                     <div
                        className="instructorProfileUI__colorButtons"
                        ref={colorButtonsRef}
                        role="group"
                        aria-label="Alege culoarea profilului"
                        onPointerDown={handleColorPointerDown}
                        onPointerMove={handleColorPointerMove}
                        onPointerUp={stopColorDrag}
                        onPointerCancel={stopColorDrag}
                        onPointerLeave={stopColorDrag}
                     >
                        {PROFILE_COLOR_PALETTE.map((color, index) => {
                           const isActive = activeColorIndex === index;

                           return (
                              <button
                                 key={color.token}
                                 type="button"
                                 data-color-index={index}
                                 className={`instructorProfileUI__colorButton ${
                                    isActive ? "is-active" : ""
                                 }`}
                                 style={{ background: color.visual }}
                                 onClick={() => setColorFromIndex(index)}
                                 aria-label={`Culoarea ${color.label}`}
                                 aria-pressed={isActive ? "true" : "false"}
                              />
                           );
                        })}
                     </div>
                  </div>

                  <div className="instructorProfileUI__field instructorProfileUI__field--full instructorProfileUI__field--panel">
                     <span className="instructorProfileUI__fieldLabel">
                        Tip instructor
                     </span>

                     <div className="instructorProfileUI__typeGrid">
                        {EDITABLE_INSTRUCTOR_TYPE_OPTIONS.map((option) => {
                           const isActive =
                              normalizeInstructorType(
                                 formData.instructorType,
                              ) === option.value;

                           return (
                              <button
                                 key={option.value}
                                 type="button"
                                 className={`instructorProfileUI__typeButton ${
                                    isActive ? "is-active" : ""
                                 }`}
                                 onClick={() => {
                                    setProfileDirty(true);
                                    setFormData((current) => ({
                                       ...current,
                                       instructorType: option.value,
                                       isExamen:
                                          option.value === "EXAMEN"
                                             ? true
                                             : current.instructorType ===
                                                 "EXAMEN"
                                               ? false
                                               : current.isExamen,
                                    }));
                                 }}
                                 aria-pressed={isActive ? "true" : "false"}
                              >
                                 {option.label}
                              </button>
                           );
                        })}
                     </div>
                  </div>

                  <div className="instructorProfileUI__field instructorProfileUI__field--full instructorProfileUI__field--inline">
                     <span className="instructorProfileUI__fieldLabel">
                        Poate examen
                     </span>

                     <UIToggle
                        checked={formData.isExamen === true}
                        onChange={(nextValue) => {
                           setProfileDirty(true);
                           setFormData((current) => ({
                              ...current,
                              isExamen: nextValue,
                              instructorType: nextValue
                                 ? "EXAMEN"
                                 : current.instructorType === "EXAMEN"
                                   ? DEFAULT_INSTRUCTOR_TYPE
                                   : current.instructorType,
                           }));
                        }}
                        aria-label="Activează instructor de examen"
                     />
                  </div>

                  <div className="instructorProfileUI__field instructorProfileUI__field--full instructorProfileUI__field--panel">
                     <span className="instructorProfileUI__fieldLabel">
                        Cutie
                     </span>

                     <div
                        className={`instructorProfileUI__radioWrapper instructorProfileUI__radioWrapper--${
                           formData.gearbox === "manual"
                              ? "left"
                              : "right"
                        }`}
                     >
                        <label className="instructorProfileUI__radioOption">
                           <input
                              type="radio"
                              name="gearbox"
                              value="manual"
                              checked={formData.gearbox === "manual"}
                              onChange={handleFormChange}
                           />
                           <span>Manual</span>
                        </label>
                        <label className="instructorProfileUI__radioOption">
                           <input
                              type="radio"
                              name="gearbox"
                              value="automat"
                              checked={formData.gearbox === "automat"}
                              onChange={handleFormChange}
                           />
                           <span>Automat</span>
                        </label>
                     </div>
                  </div>
               </div>

               {saveError && (
                  <p className="instructorProfileUI__error">
                     {saveError}
                  </p>
               )}

               <div className="instructorProfileUI__actions">
                  {canDelete ? (
                     <ConfirmDeleteButton
                        className="instructorProfileUI__deleteConfirm"
                        fullWidth={false}
                        onConfirm={handleDeleteInstructor}
                        disabled={saving || deleting}
                        label={deleting ? "Se șterge..." : "Șterge"}
                        confirmLabel={deleting ? "Se șterge..." : "Da, șterge"}
                        cancelLabel="Nu"
                        confirmTitle={ACCOUNT_DELETE_CONFIRM_TITLE}
                     />
                  ) : null}
                  <button
                     type="submit"
                     className="instructorProfileUI__button instructorProfileUI__button--save"
                     disabled={saving || deleting}
                  >
                     {saving ? "Se salvează..." : "Salvează"}
                  </button>
                  <button
                     type="button"
                     className="instructorProfileUI__button instructorProfileUI__button--secondary"
                     onClick={handleResetProfile}
                     disabled={saving || deleting}
                  >
                     Resetează
                  </button>
               </div>
            </form>
         </div>
  );
}
